import { CommentDto } from "@/api/comments/types";
import { ICallableRequestBuilder } from "@/api/requestBuilder/types";
import {
  withAuthenticatedClientRequest,
  withClientRequest,
} from "@/api/requestBuilder/withClientRequest";
import requests from "./requests";
import config from "@shared/config/client";

const toggleNftLike =
  (request: ICallableRequestBuilder<void>) => (nftId: string) => {
    return request.call(`${config.apiUrl}/likes/nft/${nftId}`, (init) => ({
      ...init,
      method: "POST",
    }));
  };

const toggleCommentLike =
  (request: ICallableRequestBuilder<CommentDto>) =>
  async (commentId: string) => {
    return request.call(
      `${config.apiUrl}/likes/nft/comment/${commentId}`,
      (init) => ({
        ...init,
        method: "POST",
      }),
    );
  };

const clientRequests = {
  toggleCommentLike: withAuthenticatedClientRequest(toggleCommentLike),
  getLikesFromNftComments: withClientRequest(requests.getLikesFromNftComments),
  toggleNftLike: withAuthenticatedClientRequest(toggleNftLike),
  getNftLikesCount: withClientRequest(requests.getNftLikesCount),
  getNftLikesBulkCount: withClientRequest(requests.getNftLikesBulkCount),
};

export default clientRequests;
